import {autoinject} from "aurelia-framework";
import {Router} from "aurelia-router";

@autoinject()
export class PageCancel{

    constructor(private router: Router) {

    }

    next() {
        this.router.navigate("page4-confirm")
    }

}